export default "__VITE_ASSET__D33$rjwg__"